import { render } from "./PanelRelatedItem.vue?vue&type=template&id=5348ddfe&scoped=true&ts=true"
import script from "./PanelRelatedItem.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItem.vue?vue&type=script&lang=ts"

import "./PanelRelatedItem.vue?vue&type=style&index=0&id=5348ddfe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5348ddfe"]])

export default __exports__